import { z } from "zod";

import { emergingThemeSchema } from "api/schemas/emergingThemesApiSchemas";
import { knowledgeSchema } from "api/schemas/knowledgeApiSchema";

// For the bookmarks response, we need a variant of the schemas where type is required
const bookmarkKnowledgeSchema = knowledgeSchema.extend({
  type: z.literal("article"),
});

const bookmarkClusterSchema = emergingThemeSchema.extend({
  type: z.literal("cluster"),
});

export const bookmarkSchema = z.discriminatedUnion("type", [bookmarkKnowledgeSchema, bookmarkClusterSchema]);

export const getBookmarksResponseSchema = z.object({
  bookmarks: z.array(bookmarkSchema),
  total: z.number(),
});

export type Bookmark = z.infer<typeof bookmarkSchema>;

export type GetBookmarksResponse = z.infer<typeof getBookmarksResponseSchema>;
